import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

type RouteRenderBoundaryProps = {
  children: React.ReactNode;
  resetKey: string;
};

type RouteRenderBoundaryState = {
  error: Error | null;
};

export default class RouteRenderBoundary extends React.Component<
  RouteRenderBoundaryProps,
  RouteRenderBoundaryState
> {
  state: RouteRenderBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): RouteRenderBoundaryState {
    return { error };
  }

  componentDidUpdate(prevProps: RouteRenderBoundaryProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <Box sx={{ py: 2 }}>
        <Stack spacing={2}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            This page hit a frontend error
          </Typography>
          <Alert severity="error">
            {this.state.error.message || 'The current route crashed while rendering.'}
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Refresh the page, or switch to another section and come back. The app shell is still running.
          </Typography>
          <Box>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Reload page
            </Button>
          </Box>
        </Stack>
      </Box>
    );
  }
}
